import { render, staticRenderFns } from "./ItemSettings.vue?vue&type=template&id=32a79ce8&scoped=true&"
import script from "./ItemSettings.vue?vue&type=script&lang=js&"
export * from "./ItemSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a79ce8",
  null
  
)

export default component.exports